import { useDispatch } from 'react-redux';

import type { Dispatch } from '@avalara/types/actions';

// react-redux v8's `useDispatch` no longer accepts our custom `Dispatch` type (which also allows
// dispatching thunks/promises/arrays) as its generic parameter, so we cast once here instead of
// at every call site. Keeping the call site a plain `useAppDispatch()` (rather than an inline
// `useDispatch() as Dispatch` cast) also keeps Biome's exhaustive-deps check recognizing `dispatch`
// as a stable hook result (see biome.json's `hooks` config). This file intentionally has no other
// dependencies so importing it doesn't pull in unrelated modules.
export const useAppDispatch = (): Dispatch => useDispatch() as Dispatch;
